module.exports = __webpack_public_path__ + "img/004.72510516.jpg";